import { ServiceDataSource } from "./service-datasource.model";

export class CmcProtocol {
    id: number;
    code: string;
    name: string;
    comment: string;
    serviceDataSources: ServiceDataSource[];
    uniqueReference: boolean;
}